import { render, staticRenderFns } from "./RemarkComponent.vue?vue&type=template&id=9f71c9ca&scoped=true"
import script from "./RemarkComponent.vue?vue&type=script&lang=js"
export * from "./RemarkComponent.vue?vue&type=script&lang=js"
import style0 from "./RemarkComponent.vue?vue&type=style&index=0&id=9f71c9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71c9ca",
  null
  
)

export default component.exports